import http from "@/http-common";

const BASE = "statistics/menu";

class MenuWeeklyStatisticsService {
  getWeeklyProgress(weekStartDate, gradeId) {
    return http.get(`${BASE}/weekly-progress`, {
      params: { weekStartDate, gradeId }
    });
  }
}

export default new MenuWeeklyStatisticsService();
